(function() {
  // Use DOMContentLoaded to ensure the DOM is ready but not delay page rendering
  document.addEventListener('DOMContentLoaded', function() {
    // Use requestAnimationFrame to run after initial rendering
    window.requestAnimationFrame(function() {
      // Get the copyright element
      const copyrightElement = document.querySelector('.footer__copyright small.copyright__content');
      
      // Exit early if element not found
      if (!copyrightElement) return;
      
      // Get the full content
      const contentText = copyrightElement.innerHTML;
      
      // Find the first period after "SOLOS Life" 
      const periodAfterSolosLife = contentText.indexOf('SOLOS Life</a>.');
      
      // Exit if we can't find the pattern
      if (periodAfterSolosLife === -1) return;
      
      // Split the content at the right position
      const copyrightPart = contentText.substring(0, periodAfterSolosLife + 14) + '. All rights reserved.'; // Include "SOLOS Life</a>."
      let acknowledgeText = contentText.substring(periodAfterSolosLife + 14).trim();
      
      // Remove the leading period if it exists (which it does based on the DOM)
      if (acknowledgeText.startsWith('.')) {
        acknowledgeText = acknowledgeText.substring(1).trim();
      }
      
      // Create two separate span elements with proper styling classes
      const acknowledgeSpan = document.createElement('span');
      acknowledgeSpan.className = 'copyright-acknowledge';
      acknowledgeSpan.innerHTML = acknowledgeText;
      
      const yearAndNameSpan = document.createElement('span');
      yearAndNameSpan.className = 'copyright-year-name';
      yearAndNameSpan.innerHTML = copyrightPart;
      
      // Replace the content
      copyrightElement.innerHTML = '';
      copyrightElement.appendChild(acknowledgeSpan);
      copyrightElement.appendChild(yearAndNameSpan);
    });
  });
})();
//<script src="{{ 'solos-scripts.js' | asset_url }}" defer="defer"></script>